import { useMemo } from "react";
import type { WorldData } from "../../domain/types";
import { FilterInput, type FilterInputOption } from "./FilterInput";

export function AirportSearch(props: { id: string; label: string; world: WorldData; value: string; onChange: (value: string) => void; disabled?: boolean }) {
  const options = useMemo<FilterInputOption[]>(
    () =>
      props.world.airports.map((airport) => {
        const detail = [airport.cityZh, airport.nameZh].filter(Boolean).join(" ");
        const keywords = [airport.code, airport.icao, airport.cityZh, airport.nameZh];
        return {
          value: airport.code,
          label: `${airport.code} / ${airport.icao}`,
          detail,
          keywords
        };
      }),
    [props.world.airports]
  );

  const selectAirport = (value: string) => {
    if (props.disabled) return;
    const normalized = value.trim().toUpperCase();
    const airport = props.world.airports.find((item) => item.code === normalized || item.icao === normalized);
    props.onChange(airport?.code ?? normalized);
  };

  return (
    <FilterInput
      id={props.id}
      label={props.label}
      query={props.value}
      options={options}
      onQueryChange={selectAirport}
      onSelect={(option) => props.onChange(option.value)}
      onInputBlur={() => selectAirport(props.value)}
      placeholder="PEK / ZBAA"
      emptyText="没有匹配机场"
      maxVisibleOptions={10}
      disabled={props.disabled}
    />
  );
}
